"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableConstants = void 0;
const tableConstants = exports.tableConstants = {
  SEARCH_PLACEHOLDER_ONBLUR: 'Search',
  SEARCH_PLACEHOLDER_ONFOCUS: 'Enter min. 3 characters',
  RESULTS_LBL_SINGULAR: 'Result',
  RESULTS_LBL_PLURAL: 'Results',
  NO_RESULTS_LBL: 'No Results',
  NO_RECORDS_FOUND_LBL: 'No Records',
  NO_COMPLETED_ACCESS_REQUESTS: 'Completed requests appear here when available'
};